import { css } from "@emotion/core"

export const list = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

export const button = css`
  display: flex;
  align-items: center;
  padding: 0;
`

export const icon = css`
  margin-right: 0.7rem;
`

export const separator = css`
  width: 0.1rem;
  height: 1.6rem;
  background-color: white;
  margin: 0 1.5rem;
`
